import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';

export const NotAuthorizedPage = () => {
  return (
    <Layout>
      <h1>Not Authorized</h1>
    </Layout>
  );
};
